<template>
  <div class="PartnerHeader">
    <div :class="{'logos':true, 'em-10-height':(showSAWBOLogo), 'em-5-height':(!showSAWBOLogo)}">
      <div class="partner-logo-cont">
        <a v-if="linkPartnerWebsite" :href="website" target="_blank">
          <img
            src="https://sawbo-animations.org/AIDI-IITA/img/iita.png"
            class="iita-logo"
          />
        </a>
      </div>
      <div class="sawbo-logo-cont" v-if="showSAWBOLogo">
        <a href="https://sawbo-animations.org" target="_blank">
          <img
            src="https://sawbo-animations.org/moalfac/img/SAWBO_Logo_500px.jpg"
            class="sawbo-logo"
          />
        </a>
      </div>
    </div>
    <div class="rapid-wordmark">{{ siteTitle }}</div>
    <nav class="rapid-bar-menu">
      <router-link 
        :class="isActive('videos')" 
        to="/"
      >{{ displayTextWrap("Videos") }}</router-link>
      <router-link 
        :class="isActive('about')" 
        to="/about"
      >{{ displayTextWrap("About") }}</router-link>
      <a
        v-if="false"
        :href="website"
        target="_blank"
        class="rapid-bar-menu-link"
        >{{ abbr }} Website</a
      >
      <a
        v-if="showSAWBOLink"
        href="https://sawbo-animations.org"
        target="_blank"
        class="rapid-bar-menu-link"
        >SAWBO Website</a
      >
      <div 
        style="width:35px;height:35px;float:right;"
        class="rapid-bar-menu-link"
        @click="showLanguageSelection"
      >
        <img src="https://sawbo-animations.org/AIDI-IITA/img/language-icon.svg" style="filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(74deg) brightness(110%) contrast(101%);">
      </div>
    </nav>
    <language-selection 
      v-if="languageSelectionVisible" 
      @close="languageSelectionVisible=false" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import LanguageSelection from "../utils/LanguageSelection";

export default {
  components: { LanguageSelection },
  name: "PartnerHeader",
  props: {},
  data() {
    return {
      languageSelectionVisible: false
    };
  },
  computed: {
    ...mapGetters(["organization", "siteInfo", "displayText", "displayTextCode"]),
    name() {
      return this.organization.name;
    },
    abbr() {
      return this.organization.abbreviation;
    },
    website() {
      return this.organization.website;
    },
    logo() {
      return this.organization.logo;
    },
    siteTitle() {
      return this.displayTextCode('site-title', 'navigation');
    },
    translatedTitle() {
      return this.siteInfo.translatedTitle;
    },
    showSAWBOLogo() {
      return this.siteInfo.showSAWBOLogo;
    },
    showSAWBOLink() {
      return this.siteInfo.showSAWBOLink;
    },
    linkPartnerWebsite() {
      if (this.siteInfo.partnerWebsite.length !== 0) {
        return true;
      } else {
        return false;
      }
    },
    showTranslations() {
      return this.siteInfo.showTranslations;
    },
    hideActiveLink() {
      return this.siteInfo.hideActiveLink;
    },
  },
  methods: {
    isActive(route) {
      let classes = "rapid-bar-menu-link";
      if(route === this.$route.name) {
        classes += " rapid-bar-menu-link-hide";
      }
      return classes;
    },
    showLanguageSelection() {
      this.languageSelectionVisible = true;
    },
    displayTextWrap(text) {
      return this.displayText(text, 'navigation');
    },
  },
};
</script>

<style scoped>

.PartnerHeader {
  width: 100%;
  padding: 2% 0;
}

.logos {
  width: 100%;
  padding: 0 5%;
  border-bottom: 2px solid #fafafa;
}

.em-10-height {
  height: 10em;
}

.em-5-height {
  height: 5em;
}

.partner-logo-cont {
  width: 45%;
  height: 100%;
  float: left;
}

.partner-logo {
  width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.sawbo-logo-cont {
  width: 45%;
  height: 100%;
  float: right;
}
.usaid-logo {
  width: 90% !important;
  float: left;
}
.iita-logo {
  width: 70% !important;
  float: left;
}
.sawbo-logo {
  width: 60%;
  max-height: 100%;
  object-fit: contain;
  vertical-align: middle;
  float:right;
}

.rapid-wordmark {
  width: 100%;
  padding: 0 24%;
  color: #3b5783;
  font-size: 1.6em;
  font-weight: bold;
  text-align: center;
}

.rapid-bar-menu {
  padding: 0.5% 5%;
  background-color: #3b5783;
  color: #ffffff;
  text-align: right;
}

.rapid-bar-menu-link {
  color: #ffffff;
  text-decoration: none;
  padding-left: 15px;
}

.rapid-bar-menu-link:hover {
  text-decoration: underline;
}

.rapid-bar-menu-link-hide {
  display: none !important;
}
</style>
